import React, { Component } from 'react';
import { Modal, Select, Button, Table, InputNumber, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import moment from 'moment';

const Option = Select.Option;

class CalculateModal extends Component {
    // 添加表格ref
    state = {
        visible: false,
        isEdit: false,
        version: undefined,
        versionList: [],
        dataSource: [],
        originalData: [],
        loading: false,
        showRequestMes: false,
    };

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.queryEmpCostVersionList();
        });
    };

    hide = () => {
        this.setState({ 
            visible: false,
            isEdit: false,
            version: undefined,
            versionList: [],
            dataSource: [],
            originalData: [],
            loading: false,
            showRequestMes: false,
        });
    };

    queryEmpCostVersionList = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEmpCostVersionList,
            data: { versionType: 'TYPE_BASIC' },
            dataType: 'json',
            doneResult: res => {
                this.setState({ 
                    versionList: res.datas || [],
                    versionId: res.datas.length > 0 ? res.datas[0].empCostCalculateVersionId : undefined,
                });
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { versionId } = this.state;
        if (!versionId) return;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryCalculateBasicDataList,
            data: { versionId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    dataSource: JSON.parse(JSON.stringify(res.datas || [] || [])),
                    originalData: JSON.parse(JSON.stringify(res.datas || [] || [])),
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    };

    handleVersionChange = (value) => {
        this.setState({ versionId: value }, () => {
            this.loadData();
        });
    };

    handleExport = () => {
        const { versionId } = this.state;
        const url = API_URL.evaluate.exportCalculateBasicDataList;
        ExportUtil.export({ versionId }, null, url);
    };

    handleEdit = () => {
        this.setState({ isEdit: true });
    };

    handleCancel = () => {
        const { originalData } = this.state;
        this.setState({
            isEdit: false,
            dataSource: JSON.parse(JSON.stringify(originalData)),
        });
    };

    handleSave = () => {
        const { dataSource, versionId } = this.state;
        // 校验必填
        const basicAmountNotInput = dataSource.some(item => !item.basicAmount);
        if(basicAmountNotInput) {
            this.setState({ showRequestMes: true }, () => {
                // 找到第一个未填写的行的索引
                const firstEmptyIndex = dataSource.findIndex(item => !item.basicAmount);
                // 滚动到第一个未填写的行
                this.scrollToFirstEmptyRow(firstEmptyIndex);
            });
            return;
        };

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            // 假设保存接口，如果url.js中没有定义，需要确认。此处使用假设的URL，或者根据上下文推断
            url: API_URL.evaluate.updateCalculateBasicDataList, 
            data: {
                calculateBasicList: JSON.stringify(dataSource),
                versionId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('保存成功');
                this.setState({
                    loading: false,
                    isEdit: false,
                    showRequestMes: false,
                });
                this.queryEmpCostVersionList();
                this.props.resetData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    };

    scrollToFirstEmptyRow = (index) => {
        // 等待DOM更新后执行滚动
        setTimeout(() => {
            // 找到CalculateModalTable下面的ant-table-body
            const tableDom = document.querySelector('.CalculateModalTable');
            if (tableDom) {
                const tableScroll = tableDom.querySelector('.ant-table-body');
                if (tableScroll) {
                    const tableBody = tableScroll.querySelector('.ant-table-tbody');
                    if (tableBody) {
                        const rows = tableBody.querySelectorAll('tr');
                        if (rows[index]) {
                            // 计算目标行的位置
                            const rowTop = rows[index].offsetTop;
                            // 设置滚动容器的scrollTop
                            tableScroll.scrollTop = rowTop - 50; // 减去100是为了让目标行显示在表格中间位置
                        }
                    }
                }
            }
        }, 0);
    };

    handleInputChange = (value, index) => {
        const { dataSource } = this.state;
        dataSource[index].basicAmount = value;
        this.setState({ dataSource });
    };

    getColumns = () => {
        const { isEdit } = this.state;
        return [
            {
                title: '报价角色定义',
                dataIndex: 'quoPositionRoleName',
                key: 'quoPositionRoleName',
                width: 150,
            },
            {
                title: '城市',
                dataIndex: 'cityLevelName',
                key: 'cityLevelName',
                width: 150,
            },
            {
                title: '计算基础',
                dataIndex: 'basicAmount',
                key: 'basicAmount',
                width: 150,
                render: (text, record, index) => {  
                    const { showRequestMes } = this.state;
                    if (isEdit) {
                        return (
                            <div>
                                <InputNumber
                                    min={0}
                                    precision={2}
                                    step={0.01}
                                    style={{ width: '100%' }}
                                    value={text}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}  //千分位展示
                                    onChange={value => this.handleInputChange(value, index)}
                                />
                                {showRequestMes && !text && <div style={{ color: 'red' }}>请输入计算基础</div>}
                            </div>
                        );
                    }
                    return text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
                }
            }
        ];
    };

    render() {
        const { visible, loading, versionId, versionList, dataSource, isEdit } = this.state;
        const showEdit = (versionList.find(item => item.empCostCalculateVersionId === versionId) || {}).versionStatus == 'CURRENT';
        return (
            <Modal
                title="计算基础"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
                width={800}
                footer={
                    showEdit &&
                    <div style={{ textAlign: 'center' }}>
                        {isEdit ? (
                            <span>
                                <Button type="primary" onClick={this.handleSave}>保存</Button>
                                <Button onClick={this.handleCancel} style={{ marginLeft: 10 }}>取消</Button>
                            </span>
                        ) : (
                            <Button type="primary" onClick={this.handleEdit}>编辑</Button>
                        )}
                    </div>
                }
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10 }}>版本：</span>
                        <Select
                            style={{ width: 200 }}
                            value={versionId}
                            onChange={this.handleVersionChange}
                            placeholder="请选择版本"
                        >
                            {versionList.map(item => (
                                <Option key={item.empCostCalculateVersionId} value={item.empCostCalculateVersionId}>{item.versionNum}</Option>
                            ))}
                        </Select>
                        {
                            versionList.length > 1 && <span style={{ marginLeft: 10 }}>更新时间：{moment(versionList[0].createTime).format('YYYY-MM-DD')}</span>
                        }
                    </div>
                    <Button type="primary" onClick={this.handleExport}>导出</Button>
                </div>
                <Table
                    bordered
                    dataSource={dataSource}
                    columns={this.getColumns()}
                    pagination={false}
                    className='CalculateModalTable'
                    ref={el => this.tableRef = el}
                    loading={loading}
                    rowKey={record => record.empCostCalculateBasicId}
                    scroll={{ y: 400 }}
                />
            </Modal>
        );
    }
}

export default CalculateModal;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/standardVisitPrice/CalculateModal.js